import { render, staticRenderFns } from "./communication-audio.vue?vue&type=template&id=4175d7de"
import script from "./communication-audio.vue?vue&type=script&lang=js"
export * from "./communication-audio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports